import { Stack } from 'libs/ui';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {}

export const ResultCheckSection = ({ ...formProps }: Props) => {
  if (!formProps.statuses?.length) {
    return null;
  }

  return (
    <Stack datax="resultCheckSection" spacing={24}>
      <FormContent {...formProps} />
    </Stack>
  );
};
